import ActionType from 'store/_utils/classes/ActionType';

import type IActionType from 'store/_utils/interfaces/IActionType';

class MyShoppingTypes {
  static list: IActionType = new ActionType('MY_SHOPPING/LIST');
  static getFiscalDocuments: IActionType = new ActionType('MY_SHOPPING/GET_FISCAL_DOCUMENTS');
  static getTickets: IActionType = new ActionType('MY_SHOPPING/GET_TICKETS');
  static getSubscriptions: IActionType = new ActionType('MY_SHOPPING/GET_SUBSCRIPTIONS');
  static getSubscriptionsNext: IActionType = new ActionType('MY_SHOPPING/GET_SUBSCRIPTIONS_NEXT');
  static getHistoryPaymentSubscriptions: IActionType = new ActionType('MY_SHOPPING/GET_HISTORY_PAYMENTS');
}

export default MyShoppingTypes;
